// src/service/ManageUserVMsService.js
import { apiClient } from "./ApiClient";

// Launch a new VM for a given org/user/instanceName
export const startUserVmAPI = (payload) =>
  apiClient
    .post("/manageuserVMs", payload)
    .then((res) => res.data);


// list all user VMs (scan tc_user_vms)
export const listUserVmsAPI = () =>
  apiClient
    .post("/manageuserVMs", { action: "listUserVms" })
    .then((res) => res.data);


export const startUserVmInstanceAPI = (instanceId) =>
  apiClient
    .post("/manageuserVMs", {
      action: "startUserVmInstance",
      instanceId,
    })
    .then((res) => res.data);

// 🔹 NEW: stop a specific VM by instance ID
export const stopUserVmInstanceAPI = (instanceId) =>
  apiClient
    .post("/manageuserVMs", {
      action: "stopUserVmInstance",
      instanceId,
    })
    .then((res) => res.data);